module.exports = __webpack_public_path__ + "img/img3.518d87d3.png";